import { Score } from "./types";
import { Schema } from "./components-from-schema/types";

export const isCsiFormCompleted = (
  formScore: Score[] | number | undefined,
  schema: string
) => {
  if (!Array.isArray(formScore)) {
    return false;
  }

  let blocksCount = 0;
  let filledRatingsCount = 0;

  const parsedSchema: Schema = JSON.parse(schema);

  parsedSchema.forEach((item) => {
    if (item.componentId.startsWith("block-")) {
      blocksCount++;
    }
  });

  formScore.forEach((item) => {
    if (item?.importance) {
      filledRatingsCount++;
    }

    if (item?.satisfaction) {
      filledRatingsCount++;
    }
  });

  return filledRatingsCount === blocksCount * 2;
};
